import { render, staticRenderFns } from "./TransactionsAdmin.vue?vue&type=template&id=d029b722&scoped=true&"
import script from "./TransactionsAdmin.vue?vue&type=script&lang=js&"
export * from "./TransactionsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsAdmin.vue?vue&type=style&index=0&id=d029b722&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d029b722",
  null
  
)

export default component.exports